import { render, staticRenderFns } from "./reportDualReferral.vue?vue&type=template&id=73307bad&scoped=true"
import script from "./reportDualReferral.vue?vue&type=script&lang=js"
export * from "./reportDualReferral.vue?vue&type=script&lang=js"
import style0 from "./reportDualReferral.vue?vue&type=style&index=0&id=73307bad&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73307bad",
  null
  
)

export default component.exports